exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir=ltr] .langHeaderUser{padding-left:2rem}[dir=rtl] .langHeaderUser{padding-right:2rem}.van-toast{z-index:9999999!important}.langHeaderUser{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;flex-direction:column;padding-bottom:1.06667rem;margin-bottom:1.06667rem;border-bottom:.02667rem solid hsla(0,0%,100%,.15)}.langHeaderUser .langHeaderUserEmail{color:hsla(0,0%,100%,.6)}.langHeaderUser .langHeaderUserId{margin-top:.13333rem;color:hsla(0,0%,100%,.6)}.langHeaderUser .langHeaderUserId i{margin-left:.26667rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1848ddef","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compontents/newHome/LanguageSwitch.vue
// module id = OaM5
// module chunks = 0